import React from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { SxProps, Theme } from '@mui/material/styles';
import { launchColors } from '../launchTheme';

interface Props {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  inputRef?: React.Ref<HTMLInputElement>;
  sx?: SxProps<Theme>;
}

const SearchField: React.FC<Props> = ({ label, value, onChange, placeholder, inputRef, sx }) => (
  <TextField
    size="small"
    label={label}
    placeholder={placeholder}
    value={value}
    inputRef={inputRef}
    onChange={(event) => onChange(event.target.value)}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon aria-hidden sx={{ fontSize: 18, color: launchColors.textMuted }} />
        </InputAdornment>
      ),
      endAdornment: value ? (
        <InputAdornment position="end">
          <IconButton size="small" aria-label="Rensa sökning" title="Rensa sökning" onClick={() => onChange('')} sx={{ p: 0.25 }}>
            <CloseIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </InputAdornment>
      ) : undefined,
    }}
    sx={sx}
  />
);

export default SearchField;
